import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Award, Sparkles, Leaf, Sun, Battery } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';

const BrandsPage = () => {
  const brands = [
    {
      name: "Jinko Solar",
      slug: "jinko-solar",
      logo: "https://jinkosolar.com.au/wp-content/themes/jinkosolar/images/logo.svg",
      category: "Solar Panels",
      categoryIcon: Sun,
      tagline: "World's #1 Solar Panel Manufacturer",
      description: "JinkoSolar is a global leader in the solar industry, recognised as Australia's favourite solar panel. With manufacturing excellence and industry-leading warranties, Jinko delivers quality, reliability and unrivalled performance.",
      highlights: ["#1 Global Manufacturer", "Top Performer - PVEL/DNV GL", "Local Australian Support"]
    },
    {
      name: "Tesla",
      slug: "tesla-powerwall",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Tesla_Motors.svg/800px-Tesla_Motors.svg.png",
      category: "Battery Storage",
      categoryIcon: Battery,
      tagline: "Security. Independence. Control.",
      description: "Tesla Powerwall is a solar battery that stores energy, detects outages and automatically becomes your home's energy source when the grid goes down. Experience true energy independence with the world's most trusted battery brand.",
      highlights: ["Automatic Backup", "Storm Watch", "24/7 Monitoring"]
    },
    {
      name: "Deye",
      slug: "deye",
      logo: "https://au.deyeinverter.com/template/eo/images/logo.png",
      category: "Hybrid Inverters & Batteries",
      categoryIcon: Battery,
      tagline: "Professional PV Inverter Manufacturer",
      description: "Ningbo Deye Inverter Technology is a leading solar inverter and hybrid system manufacturer. With over 15,000m² of production facilities and cutting-edge technology, Deye has become a major player in the global solar inverter market.",
      highlights: ["Hybrid Inverters", "98.6% Max Efficiency", "24h Support Service"]
    },
    {
      name: "WHES",
      slug: "whes",
      logo: "https://customer-assets.emergentagent.com/job_powerinnovate/artifacts/vziwce9r_logo-WHESS.png",
      category: "Battery Storage",
      categoryIcon: Battery,
      tagline: "Tier 1 Battery Energy Storage Solutions",
      description: "WHES is one of the leading battery energy storage solutions suppliers for residential, commercial, and utility applications. With comprehensive solutions from design to deployment covering 50+ countries.",
      highlights: ["AGAVE-SH & AGAVE-TH", "10-Year Warranty", "Single & Three-Phase"]
    },
    {
      name: "Sigenergy",
      slug: "sigenergy",
      logo: "https://customer-assets.emergentagent.com/job_powerinnovate/artifacts/da5t6cpp_logo-sigenergy.png",
      category: "All-in-One Energy System",
      categoryIcon: Battery,
      tagline: "World's First 5-in-1 Home Energy Solution",
      description: "Sigenergy SigenStor is a revolutionary modular all-in-one system integrating solar inverters, LiFePO4 batteries, EV charging, and smart energy management. Scalable from 5kWh to 48kWh per stack.",
      highlights: ["5-in-1 System", "10,000 Cycles", "EV Integration"]
    },
    {
      name: "Neopower",
      slug: "neopower",
      logo: "/brand-logos/neopower.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Next Generation Hot Water — Black Shield Range",
      description: "Neopower delivers premium all-in-one heat pump hot water systems engineered for Australian conditions. The Black Shield range combines a high-COP inverter compressor with R290 natural refrigerant and smart Wi-Fi control.",
      highlights: ["COP 5.4 Efficiency", "R290 Natural Refrigerant", "320L & 270L Models"]
    },
    {
      name: "Econova",
      slug: "econova",
      logo: "/brand-logos/econova.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Australian-Designed High-Efficiency Heat Pumps",
      description: "Econova is a pioneering Australian-owned designer of one of the most energy-efficient heat pump water heaters on the market. The W-Series RVW range uses R290 refrigerant, a DC inverter and variable-speed fan to deliver hot water up to 70°C.",
      highlights: ["COP up to 5.7", "R290 Natural Refrigerant", "Australian Designed"]
    },
    {
      name: "Midea",
      slug: "midea",
      logo: "/brand-logos/midea.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Australia's #1 Selling Heat Pump Brand — Simply Ideal",
      description: "Midea is a global leader ranked in the Fortune Global 500 for ten consecutive years. The Smart Saver and E-Boost heat pump ranges combine R290 refrigerant, COP 4.6, Wi-Fi control and one of the longest warranties in Australia (7 years parts and labour).",
      highlights: ["7-Year Parts & Labour Warranty", "R290 Refrigerant", "Smart Saver + E-Boost"]
    },
    {
      name: "Haier",
      slug: "haier",
      logo: "/brand-logos/haier.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Inspired Living — Award-Winning Monoblock Hot Water",
      description: "Haier is a globally recognised home-appliance brand operating in over 100 countries. The Monoblock HHB heat-pump water-heater range delivers COP up to 4.48 with R290 natural refrigerant, SmartHQ™ Wi-Fi control with 5 modes (including Solar PV) and patented triple-layer anti-corrosion tank protection.",
      highlights: ["COP up to 4.48", "R290 Refrigerant", "SmartHQ™ + Solar PV Mode"]
    },
    {
      name: "Emerald",
      slug: "emerald",
      logo: "/brand-logos/emerald.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Engineered for Effortless Efficiency — Proudly Australian since 2006",
      description: "Emerald is an Australian-owned brand engineering hot-water solutions that cost people and the planet less. The All-In-One Pro 320L range combines superior DC technology, R290 refrigerant, Wi-Fi app with Smart Actions and a diamond-enamel-coated carbon-steel tank — built for Australian conditions.",
      highlights: ["Proudly Australian since 2006", "R290 Refrigerant", "< 39 dB(A) Quiet"]
    },
    {
      name: "Reclaim Energy",
      slug: "reclaim",
      logo: "/brand-logos/reclaim.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Award-Winning Australian CO2 Heat Pump Hot Water",
      description: "Reclaim Energy is an Australian-owned company building award-winning CO2 (R744) heat pump hot water systems — up to 80% energy savings, 5× more efficient than electric or gas. 4.9★ Google rating with 148+ reviews.",
      highlights: ["Up to 80% Energy Savings*", "CO2 (R744) Refrigerant", "Wi-Fi Controller + Frost Protection"]
    },
    {
      name: "Sanden",
      slug: "sanden",
      logo: "/brand-logos/sanden.svg",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Japanese-Engineered CO2 Hot Water — The Gold Standard",
      description: "Sanden is the Japanese global pioneer of CO2 (R744) heat pump technology — co-developer of the original Eco Cute system in 2001. The Eco Plus range delivers whisper-quiet 37 dB operation and 15-year tank design life.",
      highlights: ["CO2 Heat Pump Pioneer (2001)", "37 dB(A) Whisper-Quiet", "15-Year Tank Life"]
    },
    {
      name: "iStore",
      slug: "istore",
      logo: "/brand-logos/istore.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Australian-Designed Energy Storage and Hot Water",
      description: "iStore is an Australian-designed range focused on home electrification — hot water heat pumps, pool heaters, battery storage and EV chargers. The Hot Water range delivers compact all-in-one efficiency with Aussie-tuned controls.",
      highlights: ["Proudly Australian Designed", "180L & 270L Options", "Solar-PV Smart Scheduling"]
    },
    {
      name: "Aquatech",
      slug: "aquatech",
      logo: "/brand-logos/aquatech.png",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "Australian Hot Water Specialists — Rapid Recovery",
      description: "Aquatech is an Australian hot-water specialist since 1992. The Rapid heat-pump range delivers fast hot-water recovery, low-noise operation and rebate-eligible specifications — backed by a national service network.",
      highlights: ["Australian Specialists since 1992", "Rapid Recovery", "Low-Noise Inverter"]
    },
    {
      name: "Stiebel Eltron",
      slug: "stiebel",
      logo: "/brand-logos/stiebel.svg",
      category: "Heat Pump Hot Water",
      categoryIcon: Sun,
      tagline: "German-Engineered Hot Water — Precision Since 1924",
      description: "Stiebel Eltron is a German manufacturer with over 100 years of heritage in electric water heating, hot-water heat pumps and electric space heating. The WWK series delivers German precision in integrated all-in-one designs (222L & 302L).",
      highlights: ["German Engineered Since 1924", "WWK 222 + WWK 302", "Sold in 120+ Countries"]
    },
    {
      name: "Fox ESS",
      slug: "fox-ess",
      logo: "/brand-logos/fox-ess.png",
      category: "Home Battery Storage",
      categoryIcon: Battery,
      tagline: "High-Voltage Modular Home Battery Storage",
      description: "Fox ESS engineers high-voltage LFP (LiFePO4) home batteries with a modular, plug-and-play stack design. The EQ4800, CQ6 and CQ7 ranges scale from a single 4.7 kWh module up to a 97.4 kWh wall — built for Australian single- and three-phase homes.",
      highlights: ["LFP Chemistry", "100% Usable Energy", "IP65 Outdoor Rated"]
    }
  ];

  const benefits = [
    {
      icon: Shield,
      title: "Uncompromised Quality",
      description: "Each brand is chosen through a rigorous selection process that prioritises innovation, durability, and environmental sustainability."
    },
    {
      icon: Sparkles,
      title: "Innovative Solutions",
      description: "These brands are at the forefront of renewable energy technology, offering smart, efficient, and highly effective products."
    },
    {
      icon: Award,
      title: "Guaranteed Performance",
      description: "Industry-leading warranties that guarantee your peace of mind for years to come, reflecting confidence in durability and performance."
    },
    {
      icon: Leaf,
      title: "Sustainable Impact",
      description: "Products designed with sustainability in mind, using eco-friendly manufacturing processes that reduce your carbon footprint."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 hero-gradient relative overflow-hidden">
          <div className="absolute top-20 right-10 w-72 h-72 bg-[#B5D43B]/10 rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-10 w-96 h-96 bg-[#3D5A47]/5 rounded-full blur-3xl" />
          
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center max-w-3xl mx-auto">
              <span className="inline-block text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4">
                Our Partners
              </span>
              <h1 className="heading-1 mb-6">
                Trusted <span className="text-[#B5D43B]">Brands</span> We Work With
              </h1>
              <p className="body-large text-gray-600">
                We partner only with the world's leading renewable energy brands. 
                Quality products, backed by industry-leading warranties and our local expertise.
              </p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="text-center p-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#B5D43B]/15 flex items-center justify-center mx-auto mb-4">
                    <benefit.icon className="w-7 h-7 text-[#3D5A47]" />
                  </div>
                  <h3 className="font-semibold text-[#3D5A47] mb-2">{benefit.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brands Grid */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="heading-2 text-center mb-4">Our Trusted Partners</h2>
            <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
              We are proud to be associated with brands that are universally recognised for their quality and reliability in the renewable energy sector.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {brands.map((brand, index) => (
                <Link 
                  key={index} 
                  to={`/brands/${brand.slug}`}
                  className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                  <div className="p-6">
                    {/* Header */}
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-gray-50 rounded-xl flex items-center justify-center p-2">
                          <img 
                            src={brand.logo} 
                            alt={brand.name}
                            className="max-w-full max-h-full object-contain"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = `https://ui-avatars.com/api/?name=${brand.name}&background=B5D43B&color=3D5A47&size=64`;
                            }}
                          />
                        </div>
                        <div>
                          <h3 className="font-bold text-xl text-[#3D5A47] group-hover:text-[#B5D43B] transition-colors">
                            {brand.name}
                          </h3>
                          <div className="flex items-center gap-2 mt-1">
                            <brand.categoryIcon className="w-4 h-4 text-[#B5D43B]" />
                            <span className="text-sm text-gray-500">{brand.category}</span>
                          </div>
                        </div>
                      </div>
                      <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-[#B5D43B] group-hover:translate-x-1 transition-all" />
                    </div>

                    {/* Tagline */}
                    <p className="text-[#3D5A47] font-medium mb-3">{brand.tagline}</p>

                    {/* Description */}
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                      {brand.description}
                    </p>

                    {/* Highlights */}
                    <div className="flex flex-wrap gap-2">
                      {brand.highlights.map((highlight, i) => (
                        <span 
                          key={i}
                          className="px-3 py-1 bg-[#B5D43B]/10 text-[#3D5A47] text-xs font-medium rounded-full"
                        >
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                    <span className="text-sm font-medium text-[#3D5A47] group-hover:text-[#B5D43B] transition-colors flex items-center gap-2">
                      Learn more about {brand.name}
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-[#3D5A47]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="heading-2 text-white mb-4">Ready to Get Started?</h2>
            <p className="text-white/80 mb-8 max-w-2xl mx-auto">
              Our team can help you choose the right products from our trusted brands to suit your home and budget.
            </p>
            <Link to="/contact">
              <Button className="btn-primary bg-[#B5D43B] hover:bg-[#a3c235] text-[#3D5A47] gap-2">
                Get a Free Quote
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BrandsPage;
